export const MODULE = {
    idEditCarModal : "#editCarModal",

    idEditInstructor : "#editInstructorModal",
}

export const VIEWMODAL = {
    idViewCarModal : "#viewCarModal",
}

export const FLOOR = [
    { value: 'g_floor', text: "G Floor" },
    { value: '2nd_floor', text: "2nd Floor" },
    { value: '3rd_floor', text: "3rd Floor" },
    { value: 'leaflet_point', text: "Leaflet Point" },
  ]
export const MAPFLOORTOTXT = {
    "g_floor": "G Floor",
    "2nd_floor": "2nd Floor",
    "3rd_floor": "3rd Floor",
    "leaflet_point": "Leaflet Point"
}

export const sidebarMenu = [
    { text:'Shortcuts',name:'infoShortcuts',icon :'ic-shortcut.png',path:'infoShortcuts',key:'SHORTCUTS' },
    { text:'Home',name:'infoHome',icon :'ic-home.png',path:'infoHome',key:'HOME' },
    { text:'Banner',name:'infoBanner',icon :'ic-hero-banner.png', key: 'BANNER', 
      subMenu:[
        {text:'Hero Banner',name:'infoHeroBanner',
          subMenu:[
            {text:'Hero Banner Home',name:'infoHeroBannerHome',path:'infoHeroBannerHome'},
            {text:'Hero Banner Office',name:'infoHeroBannerOfficer',path:'infoHeroBannerOfficer'},
            {text:'Hero Banner Condo',name:'infoHeroBannerCondo',path:'infoHeroBannerCondo'},
            {text:'Hero Banner Retail Center',name:'infoHeroBannerRetail',path:'infoHeroBannerRetail'},
            {text:'Hero Banner Promotion',name:'infoHeroBannerPromotion',path:'infoHeroBannerPromotion'},
          ]
        },
        {text:'Head Banner',name:'infoHeadBanner',path:'infoHeadBanner'}
      ] 
    },
    { text:'Business',name:'infoBusiness',icon :'ic-business.png', key:'BUSINESS',
      subMenu:[
        {text:'Office Building',name:'infoOfficeBuilding',
          subMenu:[
            {text:'CRC Tower',name:'infoCRCTower',path:'infoCRCTower'},
            {text:'M. Thai Tower',name:'infoMThaiTower',path:'infoMThaiTower'},
            {text:'Capital Tower',name:'infoCapitalTower',path:'infoCapitalTower'},
          ]
        },
        {text:'Retail Center',name:'infoRetailCenter',
          subMenu:[
            {text:'Retail Center Detail',name:'infoRetailCenterDetail',path:'infoRetailCenterDetail'},
            {text:'Directory',name:'infoDirectory',path:'infoDirectory'},
          ]
        },
        {text:'Condominium',name:'infoCondominium',
          subMenu:[
            {text:'Condo Manage',name:'infoCondoManage',path:'infoCondoManage'},
            {text:'Condo For Rent',name:'infoCondoRent',path:'infoCondoRent'},
            {text:'Condo For Sale',name:'infoCondoSale',path:'infoCondoSale'},
          ]
        },
      ] 
    },
    { text:'Promotion & Privileges',name:'infoPromotionPrivilege',icon :'ic-promotionprivilege.png',key:'PROMOTION_PRIVILEGE',
      subMenu:[
        {text:'Promotion',name:'infoPromotion',path:'infoPromotion'},
        {text:'Privileges',name:'infoPrivilege',path:'infoPrivilege'}
      ] 
    },
    { text:'News & Event',name:'infoNewsEvent',icon :'ic-newsevent.png',key:'NEWS_EVENT',
      subMenu:[
        {text:'News',name:'infoNews',path:'infoNews'},
        {text:'Event',name:'infoEvent',path:'infoEvent'}
      ] 
    },
    { text:'Careers Job',name:'infoCareerJob',icon :'ic-career.png',key:'CAREER',
      subMenu:[
        {text:'Content Career',name:'infoContentCareer',path:'infoContentCareer'},
        {text:'Job Position',name:'infoJobPosition',path:'infoJobPosition'},
        {text:'Job Applicants',name:'infoJobApplicants',path:'infoJobApplicants'}
      ] 
    },
    { text:'Contact Us',name:'infoContactUs',icon :'ic-contact-us.png',path:'infoContactUs',key:'CONTACT_US' },
    { text:'About Us',name:'infoAboutUs',icon :'ic-about-us.png',path:'infoAboutUs' ,key:'ABOUT_US' },
    { text:'Open Tendering Project',name:'infoTendering',icon :'ic-tendering.png',key:'OPEN_TENDERING',
      subMenu:[
        {text:'Bidding Information',name:'infoBiddingInformation',path:'infoBiddingInformation'},
        {text:'Bidding Winning',name:'infoBiddingWinning',path:'infoBiddingWinning'}
      ] 
    },
    { text:'Our Services & Privileges',name:'infoOurService',icon :'ic-our-service.png',key:'SERVICE_PRIVILEGE',
      subMenu:[
        {text:'ASP Customer Care',name:'infoCustomerCare',path:'infoCustomerCare'},
        {text:'ASP Club Lounge',name:'infoClubLounge',path:'infoClubLounge'},
        {text:'Shuttle Bus Service',name:'infoShuttleBus',path:'infoShuttleBus'},
        {text:'Carpark & Security Service',name:'infoCarpark',path:'infoCarpark'}
      ] 
    },
    { text:'Social Media',name:'infoSocialMedia',icon :'ic-social-media.png',path:'infoSocialMedia',key:'SOCIAL_MEDIA' },
    { text:'Admin User',name:'infoAdminUser',icon :'ic-users.png',key:'ADMIN_USER',
      subMenu:[
        {text:'User Manage',name:'infoUserManage',path:'infoUserManage'},
        {text:'Role Manage',name:'infoRoleManage',path:'infoRoleManage'},
      ] 
    },
  ];
 